module.exports = __webpack_public_path__ + "angular/components/admin/admin-7fff7aef.html";


//////////////////
// WEBPACK FOOTER
// ./source/angular/components/admin/admin.html
// module id = 48
// module chunks = 0